import type { JSONContent } from '@tiptap/core';
import type { TReferenceContent } from './interfaces.js';

/** The public value is editor-independent JSON: plain text (including newlines) and references. */
export const referenceDocument = (value: TReferenceContent): JSONContent => {
  const paragraphs: JSONContent[] = [{ type: 'paragraph', content: [] }];
  for (const part of value) {
    if (part.type === 'reference') {
      paragraphs.at(-1)!.content!.push({ type: 'catalogReference', attrs: { id: part.id, label: part.label } });
    } else {
      const lines = part.text.split('\n');
      lines.forEach((text, index) => {
        if (index) paragraphs.push({ type: 'paragraph', content: [] });
        if (text) paragraphs.at(-1)!.content!.push({ type: 'text', text });
      });
    }
  }
  return { type: 'doc', content: paragraphs };
};

export const referenceContent = (document: JSONContent): TReferenceContent => {
  const parts: TReferenceContent = [];
  const appendText = (text: string) => {
    if (!text) return;
    const last = parts.at(-1);
    if (last?.type === 'text') last.text += text;
    else parts.push({ type: 'text', text });
  };
  for (const [index, paragraph] of (document.content ?? []).entries()) {
    if (index) appendText('\n');
    for (const node of paragraph.content ?? []) {
      if (node.type === 'catalogReference') parts.push({ type: 'reference', id: String(node.attrs!.id), label: String(node.attrs!.label) });
      else if (node.type === 'hardBreak') appendText('\n');
      else appendText(node.text ?? '');
    }
  }
  return parts;
};
